import { useMemo, useState } from 'react';
import { Dropdown } from 'antd';
import { useModel } from '@umijs/max';
import { Country } from '@/config';
import CountryData from '@/enum/countryData';
import { currentLang, langTransition } from '@/config';

import { groupBy, isObject } from 'lodash';

import style from '../index.less';
import { changeStation } from '@/api/common';

// interface Props {}

const SelectCountry: React.FC<Props> = () => {
    const defaultCountry = Country || 'hk';
    const tabsModel = useModel('tabRoutes');
    const [country] = useState(
        CountryData.countryListData.find(
            (item) => item.code === defaultCountry.toUpperCase(),
        ),
    );

    const getName = (names) => {
        const lang = langTransition[currentLang];
        return names[lang];
    };

    const items = useMemo(() => {
        const clusters = groupBy(CountryData.countryListData, (item) =>
            isObject(item.continent) ? item.continent.default : item.continent,
        );

        return Object.keys(clusters).map((key) => {
            return {
                key,
                type: 'group',
                label: getName(CountryData.continen[key]),
                children: clusters[key].map((child) => ({
                    key: child.code,
                    // label: child.i18nName['zh-hans'],
                    label: getName({
                        ...child.i18nName,
                        en: child.enName,
                    }),
                })),
            };
        });
    }, [country]);

    const onSelect = async (item) => {
        tabsModel.removeAllTabs();
        // 切换站点免登录
        try {
            await changeStation({
                language: 'zh-CN',
                country: item.key.toLowerCase(),
            });
            window.location.href = `${window.location.origin}/${item.key}#/index`;
        } catch (e) {
            console.log('[免登录请求失败]', e);
            window.location.href = `${window.location.origin}/${item.key}#/index`;
        }
    };

    return (
        <span className={style.country_container}>
            <Dropdown
                menu={{ items, onClick: onSelect }}
                arrow
                overlayStyle={{
                    maxHeight: 400,
                    overflowY: 'auto',
                }}
            >
                <span className={style.country_title}>
                    <img
                        className={style.country_icon}
                        src={`https://global-static.popmart.com/nationalFlag/${country?.code?.toLowerCase()}.png`}
                        alt=""
                    />
                    <span>
                        {country?.i18nName
                            ? getName({
                                  ...country?.i18nName,
                                  en: country?.enName,
                              })
                            : defaultCountry}
                    </span>
                </span>
            </Dropdown>
        </span>
    );
};

export default SelectCountry;
